import { jsx, jsxs, Fragment } from "react/jsx-runtime";
import { RatingsInput, RatingsSize } from "@wix/wix-ui-tpa/cssVars";
import classNames from "classnames";
import { useRef, useCallback } from "react";
import { useFocusFieldEvent } from "../../contexts/events-context.js";
import { useTranslation } from "../../contexts/translation-context.js";
import { useFieldAttributes } from "../../services/field-attributes.js";
import { FieldDescriptionWUT } from "../field-description/field-description-wut.js";
import { FieldErrorWUT } from "../field-error/field-error-wut.js";
import { FieldLabelWUT } from "../field-label/field-label-wut.js";
import { Widget } from "../widget/widget.js";
import { classes } from "./rating-input-field-wut.st.css";
import { Fieldset } from "../fieldset/fieldset.js";
const RatingInputFieldWUT = ({
  id,
  target,
  label,
  hideLabel = false,
  required = false,
  description,
  value,
  onChange,
  onFocus,
  onBlur,
  error,
  disabled = false,
  hasError = false,
  errorMessage,
  additionalInfo,
  FieldLayout,
  requiredIndicatorType,
  requiredIndicatorPlacement,
  defaultValue,
  widgetHtml,
  widgetEnabled
}) => {
  const { t } = useTranslation();
  const { labelId, inputId, errorId, descriptionId, ariaDescribedBy } = useFieldAttributes(id, error, description);
  const inputRef = useRef(null);
  const handleChange = useCallback(
    (_value) => {
      onChange(_value);
    },
    [onChange]
  );
  const getReactionLabel = useCallback(
    (_value) => t("rating-input.a11y.reaction-label", { count: _value }),
    [t]
  );
  useFocusFieldEvent(() => {
    inputRef.current?.focus({ preventScroll: true });
  }, id);
  return /* @__PURE__ */ jsx(
    FieldLayout,
    {
      fieldId: id,
      renderLabel: () => /* @__PURE__ */ jsx(
        FieldLabelWUT,
        {
          labelId,
          htmlFor: inputId,
          required,
          label,
          hideLabel,
          requiredIndicatorType,
          requiredIndicatorPlacement
        }
      ),
      renderInput: () => widgetHtml && widgetEnabled ? /* @__PURE__ */ jsx(
        Widget,
        {
          fieldId: id,
          widgetHtml,
          onChange,
          value
        }
      ) : /* @__PURE__ */ jsx(
        Fieldset,
        {
          id: inputId,
          ariaLabelledBy: labelId,
          ariaDescribedBy,
          onFocus,
          onBlur,
          required,
          children: /* @__PURE__ */ jsx(
            RatingsInput,
            {
              value: value || defaultValue || 0,
              onSelect: handleChange,
              size: RatingsSize.Large,
              disabled,
              className: classNames(classes.rating, {
                [classes.error]: hasError
              }),
              getReactionLabel,
              showReactionLabel: false,
              ref: inputRef
            }
          )
        }
      ),
      renderDescription: () => /* @__PURE__ */ jsxs(Fragment, { children: [
        /* @__PURE__ */ jsx(
          FieldErrorWUT,
          {
            target,
            hasError,
            errorMessage,
            id: errorId
          }
        ),
        /* @__PURE__ */ jsx(FieldDescriptionWUT, { description, id: descriptionId }),
        additionalInfo
      ] })
    }
  );
};
export {
  RatingInputFieldWUT
};
//# sourceMappingURL=rating-input-field-wut.js.map
